import { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import * as telegramApi from '../../api/telegram.api';
import styles from './SettingsPage.module.css';

export function SettingsPage() {
  const { user } = useAuth();
  const [telegramLinked, setTelegramLinked] = useState(false);
  const [telegramId, setTelegramId] = useState<string | null>(null);
  const [tgConnecting, setTgConnecting] = useState(false);
  const [tgFallbackLink, setTgFallbackLink] = useState<string | null>(null);

  useEffect(() => {
    telegramApi.getTelegramStatus().then((status) => {
      setTelegramLinked(status.linked);
      if (status.telegramId) setTelegramId(String(status.telegramId));
    }).catch(() => {});
  }, []);

  const handleConnectTelegram = async () => {
    setTgConnecting(true);
    setTgFallbackLink(null);
    const popup = window.open('', '_blank');
    try {
      const result = await telegramApi.generateTelegramLink();
      if (popup && !popup.closed) {
        popup.location.href = result.deepLink;
      } else {
        setTgFallbackLink(result.deepLink);
      }
    } catch {
      if (popup && !popup.closed) popup.close();
    } finally {
      setTgConnecting(false);
    }
  };

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Настройки</h1>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Аккаунт</h2>
        <Card className={styles.settingCard}>
          <div className={styles.settingRow}>
            <div className={styles.settingInfo}>
              <div className={styles.settingLabel}>Email</div>
              <div className={styles.emailValue}>{user?.email}</div>
            </div>
          </div>
        </Card>
        <Card className={styles.settingCard}>
          <div className={styles.settingRow}>
            <div className={styles.settingInfo}>
              <div className={styles.settingLabel}>Telegram</div>
              <div className={styles.emailValue}>
                {telegramLinked ? (
                  <Badge variant="success">Подключён (ID: {telegramId})</Badge>
                ) : (
                  <span className={styles.settingHint}>Не подключён</span>
                )}
              </div>
            </div>
            {!telegramLinked && (
              <Button
                variant="primary"
                size="sm"
                loading={tgConnecting}
                onClick={handleConnectTelegram}
              >
                Подключить
              </Button>
            )}
          </div>
          {!telegramLinked && tgFallbackLink && (
            <div className={styles.tgFallback}>
              <p className={styles.settingHint}>
                Браузер заблокировал автоматическое открытие. Нажмите, чтобы открыть бота в Telegram
              </p>
              <a href={tgFallbackLink} target="_blank" rel="noopener noreferrer">
                <Button variant="secondary" size="sm">
                  Открыть Telegram
                </Button>
              </a>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
